<template>
  <div>
    <Head title="Add Lead" />

    <div class="grid grid-cols-5 gap-4">
      <div class="col-span-5 lg:col-span-3">
        <h1 class="mb-8 font-bold text-3xl">
          <Link class="text-indigo-400 hover:text-indigo-600" href="/leads">Leads </Link>
          <span class="text-indigo-400 font-medium">/</span> Add Lead
        </h1>
        <div class="bg-white rounded-md shadow overflow-hidden w-full">
          <form @submit.prevent="store">
            <div class="p-8 -mr-6 flex flex-wrap">
              <select-input v-model="form.status" :error="form.errors.status" class="pr-6 pb-8 w-full lg:w-1/2" label="Lead Status">
                <option :value="null" />
                <option value="2">New</option>
                <option value="28">App Complete</option>
                <option value="6">Contacted</option>
                <option value="7">Waiting</option>
                <option value="8">Not Interested</option>
                <option value="9">Not Eligible</option>
                <option value="10">No Response</option>
                <option value="11">Processing</option>
                <option value="12">Closed</option>
                <option value="13">PreApproved</option>
                <option value="14">Do Not Contact</option>
                <option value="16">Credit Repair</option>
                <option value="17">Rate Watch</option>
                <option value="20">Call Back</option>
              </select-input>
              <select-input v-model="form.user_id" :error="form.errors.user_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Loan Officer">
                <option v-for="user in users" :key="user.id" :value="user.id">{{ user.first_name }} {{ user.last_name }}</option>
              </select-input>
              <h2 class="text-lg font-semibold text-gray-700 capitalize dark:text-white w-full pb-8">Contact Information</h2>
              <text-input v-model="form.fullName" :error="form.errors.fullName" class="pr-6 pb-8 w-full lg:w-1/2" label="Full Name" />
              <text-input v-model="form.nickname" :error="form.errors.nickname" class="pr-6 pb-8 w-full lg:w-1/2" label="Nickname" />
              <text-input v-model="form.birthday" type="date" :error="form.errors.birthday" class="pr-6 pb-2 w-full lg:w-1/2" label="Birthday" />
              <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-2 w-full lg:w-1/2" label="Email" />
              <phone-input v-model.phoneFormat="form.phone" :type="phone" :error="form.errors.phone" class="relative pr-6 pb-2 w-full lg:w-1/2" label="Phone" />
              <div class="w-full pb-8">
                <div v-show="!toggle" class="duration-300" @click="toggle = !toggle">
                  <i class="fas fa-user-plus mt-5 w-full" /> Show Co-Borrower
                </div>
                <div v-show="toggle" class="duration-300" @click="toggle = !toggle">
                  <i class="fas fa-user-minus mt-5 w-full" /> Hide Co-Borrower
                </div>
              </div>
              <div v-show="toggle" id="coborrower" class="transition duration-300 ease-in-out w-full flex flex-wrap">
                <text-input v-model="form.fullNameCoborrower" :error="form.errors.fullNameCoborrower" class="pr-6 pb-8 w-full lg:w-1/2" label="Co-Borrower Full Name" />
                <text-input v-model="form.nicknameCoborrower" :error="form.errors.nicknameCoborrower" class="pr-6 pb-8 w-full lg:w-1/2" label="Co-Borrower Nickname" />
                <text-input v-model="form.birthdayCoborrower" type="date" :error="form.errors.birthdayCoborrower" class="pr-6 pb-2 w-full lg:w-1/2" label="Co-Borrower Birthday" />
                <text-input v-model="form.emailCoborrower" :error="form.errors.emailCoborrower" class="pr-6 pb-8 w-full lg:w-1/2" label="Co-Borrower Email" />
                <phone-input v-model.phoneFormat="form.phoneCoborrower" :type="phone" :error="form.errors.phoneCoborrower" class="relative pr-6 pb-2 w-full lg:w-1/2" label="Co-Borrower Phone" />
              </div>
              <h2 class="text-lg font-semibold text-gray-700 capitalize dark:text-white w-full pb-8">Home Information</h2>
              <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-4 w-full" label="Address" />
              <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-4 w-full lg:w-1/3" label="City" />
              <text-input v-model="form.state" :error="form.errors.state" class="pr-6 pb-4 w-full lg:w-1/3" label="State" />
              <text-input v-model="form.zip" :error="form.errors.zip" class="pr-6 pb-4 w-full lg:w-1/3" label="Zip" />
              <h2 class="text-lg font-semibold text-gray-700 capitalize dark:text-white w-full pb-8">Loan Information</h2>
              <select-input v-model="form.goal" :error="form.errors.goal" class="pr-6 pb-4 w-full lg:w-1/4" label="Goal">
                <option :value="null" />
                <option value="Purchase">Purchase</option>
                <option value="Refinance">Refinance</option>
                <option value="Cashout">Cashout</option>
                <option value="Shorten Term">Shorten Term</option>
                <option value="Other">Other</option>
              </select-input>
              <select-input v-model="form.loan_type" :error="form.errors.loan_type" class="pr-6 pb-4 w-full lg:w-1/4" label="Loan Type">
                <option :value="null" />
                <option value="Conventional">Conventional</option>
                <option value="FHA">FHA</option>
                <option value="FHA 203K">FHA 203K</option>
                <option value="FHA Streamline">FHA Streamline</option>
                <option value="VA">VA</option>
                <option value="USDA">USDA</option>
                <option value="DSCR">DSCR</option>
                <option value="Jumbo">Jumbo</option>
                <option value="HELOC">HELOC</option>
                <option value="Investment">Investment</option>
                <option value="Vacation Home">Vacation Home</option>
                <option value="Manufactured">Manufactured</option>
                <option value="Park Loan">Park Loan</option>
                <option value="Reverse">Reverse</option>
                <option value="Construction">Construction</option>
                <option value="Land">Land</option>
                <option value="Other">Other</option>
              </select-input>
              <select-input v-model="form.rating" :error="form.errors.rating" class="pr-6 pb-4 w-full lg:w-1/4" label="Rating">
                <option :value="null" />
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select-input>

              <select-input v-model="form.credit" :error="form.errors.credit" class="pr-6 pb-4 w-full lg:w-1/4" label="Credit">
                <option :value="null" />
                <option value="Excellent 720+">Excellent 720+</option>
                <option value="Good 660-719">Good 660-719</option>
                <option value="Average 600-659">Average 600-659</option>
                <option value="Below Avg 580-599">Below Avg 580-599</option>
                <option value="Poor 579 or Less">Poor 579 or Less</option>
              </select-input>
              <text-input v-model="form.closed" type="date" :error="form.errors.closed" class="pr-6 pb-4 w-full lg:w-1/4" label="Closed" />
              <text-input v-model="form.rate" :error="form.errors.rate" class="pr-6 pb-4 w-full lg:w-1/4" label="Rate" />
              <text-input v-model="form.balance" :error="form.errors.balance" class="pr-6 pb-6 w-full lg:w-1/4" label="Loan Balance" />
              <select-input v-model="form.contact_id" :error="form.errors.contact_id" class="pb-4 pr-6 w-full lg:w-1/4" label="Referral Contact" @blur="update">
                <option :value="null" />
                <option v-for="contact in contacts" :key="contact.id" :value="contact.id">{{ contact.name }}</option>
              </select-input>
              <div class="w-full pb-8">
                <div v-show="!toggle2" class="duration-300" @click="toggle2 = !toggle2">
                  <i class="fas fa-user-plus mt-5 w-full" /> Show Meta Info
                </div>
                <div v-show="toggle2" class="duration-300" @click="toggle2 = !toggle2">
                  <i class="fas fa-user-minus mt-5 w-full" /> Hide Meta Info
                </div>
              </div>
              <div v-show="toggle2" id="metaInfo" class="transition duration-300 ease-in-out w-full flex flex-wrap">
                <text-input v-model="form.referringUrl" :error="form.errors.referringUrl" class="pr-6 pb-6 w-full lg:w-1/2" label="Referring URL" />
                <text-input v-model="form.url" :error="form.errors.url" class="pr-6 pb-6 w-full lg:w-1/2" label="Website Address" />
                <text-input v-model="form.floifyLoan" :error="form.errors.floifyLoan" class="pr-6 pb-6 w-full lg:w-1/2" label="Floify Link" />
                <text-input v-model="form.ip" :error="form.errors.ip" class="pr-6 pb-6 w-full lg:w-1/2" label="IP Address" />
              </div>
              <textarea-input v-model="form.message" rows="3" :error="form.errors.message" class="pr-6 pb-8 w-full" label="Message">Message</textarea-input>
            </div>
            <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
              <loading-button :loading="form.processing" class="btn-indigo" type="submit">Add Lead</loading-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link, router } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import PhoneInput from '@/Shared/PhoneInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    PhoneInput,
  },
  layout: Layout,
  props: {
    users: Array,
    contacts: Array,
    auth: Object,
  },
  remember: 'form',
  data() {
    return {
      form: router.form({
        fullName: null,
        nickname: null,
        loan_type: null,
        phone: null,
        goal: null,
        email: null,
        message: null,
        birthday: null,
        fullNameCoborrower: null,
        nicknameCoborrower: null,
        birthdayCoborrower: null,
        emailCoborrower: null,
        phoneCoborrower: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        url: null,
        ip: null,
        referringUrl: null,
        agent: null,
        status: null,
        closed: null,
        contact_id: null,
        sms_enabled: null,
        email_enabled: null,
        pre_approval_sms: null,
        rating: null,
        floifyLoan: null,
        credit: null,
        balance: null,
        user_id: null,
        automations: null,
      }),
      toggle: false,
      toggle2: false,
    }
  },
  created(){
    this.form.user_id = this.auth.user.id
  },
  methods: {
    store() {
      this.form.post('/leads')
    },
  },
}
</script>
